import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ConfirmationDialogProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
  open: boolean;
  onClose: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel || onClose} color="error" variant="outlined">
          <FormattedMessage id="confirmation-dialog.cancel" />
        </Button>
        <Button onClick={onConfirm} variant="contained">
          <FormattedMessage id="confirmation-dialog.confirm" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
